import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Dropdown, Button} from 'semantic-ui-react';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {paths} from '../../../common/dictionaries/urls';
import {Actions} from '../../../common/actions';
import OrdersListTable from './table';
import Details from './details';
import LimitControl from './limitControl';
import GenerateTxtModal from './modal/generateTxt';
import './specials.scss';

class SpecialOrders extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'showDetails': false,
      'providerTmp': 'all',
      'providerSelected': 'all',
      'orderTypeTmp': '',
      'orderTypeSelected': '',
      'indexItemSelected': '',
    };
    this.handleRefreshClick = this.handleRefreshClick.bind(this);
    this.chooseItem = this.chooseItem.bind(this);
  }

  componentDidMount() {
    if (!hasAccessPermission(this.props.permissions, resources.ProviderSpecialOrders, scopes.Create)) {
      this.props.navigateTo(paths.AccessDenied);
    }
    const date = new Date();
    this.props.loadProviders({'withOrigin': true});
    this.props.getProviderOrderLimit({'year': date.getFullYear()});
    this.fetchProviderOrders();
  }

  handleRefreshClick() {
    const date = new Date();
    this.fetchProviderOrders();
    this.props.getProviderOrderLimit({'year': date.getFullYear()});
  }

  fetchProviderOrders() {
    const {providerSelected} = this.state;
    let providerCode = null;
    if (providerSelected && providerSelected !== 'all') {
      providerCode = providerSelected;
    }
    this.props.fetchProviderSpecialOrders(providerCode);
  }

  chooseItem(index) {
    this.hideOrShowDetails(true, index);
  }

  hideOrShowDetails(value, index) {
    this.setState({'showDetails': value, 'indexItemSelected': index});
  }

  getProviders() {
    const dealers = this.props.providers.map((dealer) => {
      return {'text': dealer.name, 'value': dealer.code};
    });
    dealers.unshift({'text': 'Todos los proveedores', 'value': 'all'});
    return dealers;
  }

  updateProviderFilter(value) {
    this.setState({'providerTmp': value}, () => this.updateDataForProvider());
  }

  updateDataForProvider() {
    const {providerSelected, providerTmp} = this.state;
    if (providerSelected === providerTmp) {
      return;
    }
    this.setState({'providerSelected': providerTmp, 'showDetails': false}, () => this.fetchProviderOrders());
  }

  renderDetails() {
    const {showDetails, indexItemSelected} = this.state;
    const {providersOrdersList} = this.props;
    if (!showDetails) {
      return null;
    }
    return <Details onCloseDetailCard={this.hideOrShowDetails.bind(this, false, null)}
      itemSelected={providersOrdersList[indexItemSelected]} />;
  }

  render() {
    const {providerTmp, providerSelected, showDetails} = this.state;
    const {loadingProviders, loadingProviderOrders, rejectingOrder, generatingTxt} = this.props;

    return (
      <div className='provider-specials-orders'>
        <Card raised fluid>
          <div className='title-bar'>
            <div className='title'>
              <h2>Pedidos Especiales - Proveedores</h2>
              <div className='title-bar-actions'>
                <h4>Proveedor</h4>
                <Dropdown selection
                  options={this.getProviders()}
                  search
                  value={providerTmp}
                  loading={loadingProviders}
                  disabled={loadingProviderOrders || rejectingOrder || generatingTxt}
                  onChange={(e, {value}) => this.updateProviderFilter(value)}
                  placeholder='Seleccionar'
                  noResultsMessage='Proveedor no encontrado'
                />
                <Button secondary onClick={this.handleRefreshClick}>ACTUALIZAR</Button>
                <GenerateTxtModal providerId={providerSelected}
                  disabled={!providerSelected || providerSelected === 'all' ||
                  loadingProviderOrders || rejectingOrder || generatingTxt}
                  onCloseDetailCard={this.hideOrShowDetails.bind(this, false, null)} />
              </div>
            </div>

            <div className='subtitle'>
              Toyota del Ecuador S.A.
              <div className='control-section'>
                <LimitControl />
              </div>
            </div>
          </div>
        </Card>

        <OrdersListTable showDetails={showDetails} onSelectItem={this.chooseItem} provider={providerTmp} />

        {this.renderDetails()}

      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loadingProviders': state.provider.loading,
    'providers': state.provider.list,
    'loadingProviderOrders': state.providerOrdersList.loading,
    'providersOrdersList': state.providerOrdersList.list,
    'rejectingOrder': state.providerOrdersList.rejecting,
    'generatingTxt': state.providerOrdersList.generatingTxt,
    'permissions': state.session.permissions,
  };
};

const {withRouter, navigateTo, loadProviders, fetchProviderSpecialOrders, getProviderOrderLimit} = Actions;

export default withRouter(connect(mapStateToProps, {
  navigateTo,
  loadProviders,
  fetchProviderSpecialOrders,
  getProviderOrderLimit,
})(SpecialOrders));
